/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const changeIncidentTeamHeadersIdempotencyKeyMin = 16;
export const changeIncidentTeamHeadersIdempotencyKeyMax = 128;

export const changeIncidentTeamHeadersIdempotencyKeyRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const ChangeIncidentTeamHeaders = zod.object({
  'Idempotency-Key': zod
    .string()
    .min(changeIncidentTeamHeadersIdempotencyKeyMin)
    .max(changeIncidentTeamHeadersIdempotencyKeyMax)
    .regex(changeIncidentTeamHeadersIdempotencyKeyRegExp),
  'x-csrf-token': zod.string(),
});

export type ChangeIncidentTeamHeaders = zod.input<typeof ChangeIncidentTeamHeaders>;
export type ChangeIncidentTeamHeadersOutput = zod.output<typeof ChangeIncidentTeamHeaders>;
